import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';

import { emitChatsCustomEvent, deleteChatItem } from '../../../../../../data/redux/chats_details/actions';
import { startPageLoading, stopPageLoading } from '../../../../../../data/redux/page_details/actions';
import { emitMemberCustomEvent, loadAgentListForSelectedGroup, updateMemberState } from '../../../../../../data/redux/member_details/actions';
import { SOCKET_EVENTS, CHAT_TRANSFER_TO } from '../../../../../../data/config/constants';
import { showMessage } from '../../../../../../data/config/utils';

import TransferChat from './transferchat';

class ChatDrawer extends React.PureComponent {
  transferToAgent = (transferType, agent) => {
    const { transfer_chat, selected_active_chat_id, is_chats_socket_connected, admin_id, actions, closeDrawer } = this.props;
    if (selected_active_chat_id && is_chats_socket_connected) {
      let payload = {
        transferType,
        clientPsid: selected_active_chat_id,
        senderAgentPsid: admin_id,
      };
      if (transferType === CHAT_TRANSFER_TO.AGENT)
        payload.requestedAgentPsid = agent.psid;
      else if (transferType === CHAT_TRANSFER_TO.GROUP)
        payload.group = transfer_chat.selectedGroup;
      actions.startPageLoading('transfering chat');
      actions.emitChatsCustomEvent(SOCKET_EVENTS.TRANSFER_CHAT, payload, (err, res) => {
        actions.stopPageLoading();
        if (!err && res && res.data && res.data.transferedChat && res.data.transferedChat.psid) {
          actions.deleteChatItem({ psid: res.data.transferedChat.psid });
          const data = {
            selected_group: "",
            agent_list: {},
          };
          actions.updateMemberState(data, 'transfer_chat');
          closeDrawer();
          showMessage('success', res && res.message ? res.message : "chat transfered to agent successfully");
        } else
          showMessage('error', res && res.message ? res.message : "transfer chat event error occured.");
      });
    } else
      showMessage('warning', is_chats_socket_connected ? "please socket is not connect yet" : "chat has been disconnected");
  };

  onChangeTransferChatSelectedGroup = group => {
    const { actions, selected_active_chat_id } = this.props;
    if (selected_active_chat_id) {
      const payload = {
        group,
        clientPsid: selected_active_chat_id,
      };
      actions.loadAgentListForSelectedGroup(payload);
    } else
      showMessage('warning', 'chat is either disconnected or force taken over by someone')
  };

  leaveAgentTransfer = () => {
    const { actions } = this.props;
    actions.emitMemberCustomEvent(SOCKET_EVENTS.LEAVE_AGENT_TRANSFER, {});
  };

  render() {
    const { screen_width, admin_id, groups, transfer_chat, drawer_data, closeDrawer } = this.props;
    return (
      <Drawer className="ori-drawer ori-drawer-title-primary ori-drawer-body-no-pad ori-drawer-height-without-footer ori-drawer-bg-default" width={screen_width < 768 ? screen_width : 500} title={drawer_data.title} visible={drawer_data.show_transfer_chat} placement="right" maskClosable={false} onClose={closeDrawer}>
        {
          drawer_data.show_transfer_chat &&
          <div className="ori-full-parent-height ori-overflow-y-auto ori-overflow-x-hidden">
            <TransferChat admin_id={admin_id} groups={groups} transfer_chat={transfer_chat} onChangeGroup={this.onChangeTransferChatSelectedGroup} transferToAgent={this.transferToAgent} leaveAgentTransfer={this.leaveAgentTransfer} />
          </div>
        }
      </Drawer>
    );
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    admin_id: state.admin_details.admin_id,
    groups: state.member_details.groups,
    transfer_chat: state.member_details.transfer_chat,
    selected_active_chat_id: state.chats_details.selected_active_chat_id,
    is_chats_socket_connected: state.chats_details.is_socket_connected,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        emitMemberCustomEvent,
        loadAgentListForSelectedGroup,
        updateMemberState,
        startPageLoading,
        stopPageLoading,
        emitChatsCustomEvent,
        deleteChatItem,
      },
      dispatch),
  };
};

ChatDrawer.propTypes = {
  screen_width: PropTypes.number,
  admin_id: PropTypes.string,
  groups: PropTypes.array,
  actions: PropTypes.object,
  selected_active_chat_id: PropTypes.string,
  transfer_chat: PropTypes.object,
  is_chats_socket_connected: PropTypes.bool,
  closeDrawer: PropTypes.func,
  drawer_data: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatDrawer);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/components/chatdrawer/index.js